export const checkIsAdmin = (val) => {
  switch (String(val)) {
    case '1':
      return false;
      break;
    case '2':
      return false;
      break;
    case '3':
      return true;
      break;
    case '4':
      return true;
      break;
    case '5':
      return true;
      break;
    case '6':
      return false;
      break;

    default:
      return null;
      break;
  }
};
